import { tableInputClasses } from './lifecareStudioClasses';
import {
  blockNegativeNumberInputKeys,
  clampNonNegativeNumberInputValue,
  toNumberInputValue,
} from '../../utils/lifecarePlanUtils';

const LifecareStudioNumberInput = ({
  value,
  step = '1',
  ariaLabel,
  className = tableInputClasses,
  onValueChange,
}) => (
  <input
    type="number"
    min={0}
    step={step}
    aria-label={ariaLabel}
    className={className}
    value={toNumberInputValue(value)}
    onKeyDown={blockNegativeNumberInputKeys}
    onChange={(event) => onValueChange(clampNonNegativeNumberInputValue(event.target.value))}
  />
);

export default LifecareStudioNumberInput;
